// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2U5Gv","content":"Consent_content__1qcZD","footer":"Consent_footer__2JXZH"};